import { ImmerReducer } from 'use-immer';
import { CaptureAction, CaptureState } from './type';

const captureReducer: ImmerReducer<CaptureState, CaptureAction> = (state, action) => {
  switch (action.type) {
    case 'SET_CAMERA':
      state.cameraList = action.payload;
      break;
    case 'SET_MICROPHONE':
      state.micList = action.payload;
      break;
    case 'CHANGE_RESOLUTION': {
      const [width, height] = action.payload.split('x').map(Number);

      state.selectedResolution = state.resolutionList.find(
        (s) => s.width === width && s.height === height
      );
      break;
    }
    case 'CHANGE_ENABLE_MIC':
      state.enableMic = action.payload;
      break;
    case 'SET_MEDIA_RECORDER':
      state.mediaRecorder = action.payload;
      break;
    case 'STOP_MEDIA_RECORDER':
      if (action.payload) {
        state.mediaRecorder?.stop();
        state.recordStream?.getTracks().forEach((track) => track.stop());
      }
      break;
    case 'CHANGE_SELECTED_CAMERA':
      state.selectedVideo = action.payload;
      break;
    case 'CHANGE_SELECTED_MICROPHONE':
      state.selectedMic = action.payload;
      break;
    case 'SET_RESOLUTION_LIST':
      state.resolutionList = action.payload;
      state.selectedResolution = action.payload[0];
      break;

    case 'CLEAN':
      if (state.mediaRecorder) {
        state.mediaRecorder.stop();
        state.mediaRecorder = null;
      }

      if (state.recordStream) {
        state.recordStream.getTracks().forEach((track) => track.stop());
        state.recordStream = null;
      }
      break;
    case 'SET_IS_GRANTED':
      state.isGranted = action.payload;
      break;
    case 'SET_RECORD_STREAM':
      state.recordStream = action.payload;
      break;
    case 'START_TIMER':
      state.intervalId = action.payload;
      break;
    case 'TICK':
      state.elapsedTime += 1;
      break;
    case 'STOP_TIMER':
      clearInterval(state.intervalId);
      state.elapsedTime = 0;
      state.intervalId = null;
      break;
    case 'PAUSE_TIMER':
      clearInterval(state.intervalId);
      state.intervalId = null;
      break;
    case 'SET_FULLSCREEN':
      state.isFullScreen = action.payload;
      break;
    default:
      break;
  }
};

export default captureReducer;
